module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1048-858e16bc0e603d0529427f5c597aa0e0.png";